<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Investment</li></a>
      <a  @click="insuranceDashbord"><li>&nbsp;>&nbsp;Insurance Dashboard</li></a>
      <a  @click="insuranceAccounts"><li>&nbsp;>&nbsp;Insurance</li></a>

      <li>&nbsp;>&nbsp;Property Insurance</li>
    </ul>
    <h4 class="welcome-text">Property Insurance</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
            <h4>Enter Details</h4>
            <div class="OrBox" style="text-align: center;padding: 20px 0px;max-width: 709px;font-weight: 700;font-size: 20px;">OR</div>
            <v-row >
              <v-col xs="12" md="6" class="member_relation_box col" v-for="formAttr in formAttributes" :key="formAttr.id" v-if="formAttr['name']!='add_on_1_premium' && formAttr['name']!='add_on_2_premium' && formAttr['name']!='add_on_3_premium' && formAttr['name']!='add_on_4_premium' && formAttr['name']!='add_on_5_premium' && formAttr['name']!='add_on_1_sum_assured' && formAttr['name']!='add_on_2_sum_assured' && formAttr['name']!='add_on_3_sum_assured' && formAttr['name']!='add_on_4_sum_assured' && formAttr['name']!='add_on_5_sum_assured'">
                <label class="member-label" v-if="formAttr['name'] =='current_balance'">{{formAttr['label']}} As On {{currentDate | moment("DD MMM, YY")}}</label>
                <label class="member-label" v-else>{{formAttr['label']}} </label>
                <div v-if="formAttr['type'] == 'select' && formAttr['name'] !='insured_member_1' && formAttr['name'] !='add_on_1_policy_name' && formAttr['name'] !='insurance_company'">
                  <v-select 
                    ref="form_attrs"
                    :name="formAttr['name']" 
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='insurance_company' )? getLifeInsuranceCompany : (formAttr['name']=='policy_name') ? policyName : (formAttr['name']=='account_owner')? account_owner : (formAttr['name']=='policy_owner') ? policy_owner :familyMember"
                    item-value="id"
                    item-text="name"
                    :value="formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'select'  && formAttr['name'] =='insurance_company'">
                  <v-select 
                    ref="form_attrs"
                    :name="formAttr['name']" 
                    v-model="insurance_company"
                    :items="getLifeInsuranceCompany"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'select' && formAttr['name'] =='insured_member_1'">
                   <v-combobox
                    :ref="formAttr['name']"
                    :name="formAttr['name']" 
                    :items="insured_member"
                    item-value="id"
                    item-text="name"
                    :value="formAttr['value']"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                    multiple
                    small-chips
                    solo
                    v-on:input="limiter"
                    deletable-chips
                  ></v-combobox>
                </div>
                <div v-else-if="formAttr['type'] == 'select' && formAttr['name'] =='add_on_1_policy_name'">
                  
                    <v-combobox
                    :ref="formAttr['name']"
                    :name="formAttr['name']" 
                    v-model="selectedAddOnPolicyName"
                    :items="addOnPolicyName"
                    item-value="id"
                    item-text="name"
                    :value="formAttr['value']"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                    multiple
                    small-chips
                    solo
                    deletable-chips
                    @click:close="limiter"
                  ></v-combobox>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'uin_number'">
                  <v-text-field
                  :name="formAttr['name']"
                  ref="form_attrs" 
                  :rules="formAttr['is_required'] == false ? [ v => !v || /^\d*\.?\d*$/.test(v) || 'Field must be numeric',v => !v || v.length >= 10 || 'Please enter valid UIN']:[]"
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="validateUIN($event)"
                  :value="formAttr['value']"
                  ></v-text-field>
              </div>
               <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] != 'account_no'" :class="(formAttr['name'] == 'amount_invested' || formAttr['name'] == 'current_balance'||  formAttr['name'] == 'maturity_amount')? 'rupee-icon' : ''">
                    <v-text-field
                    :readonly="(formAttr['name'] == 'policy_type' ) || (formAttr['name'] == 'maturity_amount') ? true: false"
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="[(formAttr['is_required'] ==true ? v => !!v || 'Field is required':[]),(formAttr['is_numeric'] ==true ? v => /^\d{0,8}[.]?\d{1,2}$/.test(v) || 'Field must be numeric':[])]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    :value="formAttr['name'] == 'policy_type'? formAttr['value']:formAttr['name'] == 'maturity_amount'? maturity_balance_value:formAttr['value']"
                    @input="changeTextFieldEvent"
                    ></v-text-field> 
                </div>
                <div v-else-if="formAttr['type'] == 'date' && formAttr['name']=='start_date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="dd MMM, yyyy"
                    :placeholder="formAttr['place_holder']"
                    :disabledDates="disabledDates"
                    :value="formAttr['value']"
                  ></Datepicker>
                </div>
                <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="dd MMM, yyyy"
                    :placeholder="formAttr['place_holder']"
                    :disabledDates="formAttr['name'] == 'end_date' ? disabledDatesforMaturity : {}"
                    :value="formAttr['value']"
                  ></Datepicker>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 0">
                <label class="member-label">ADD ON 1 PREMIUM</label>
                <div>
                  <v-text-field
                  name="add_on_1_premium"
                  ref="form_attrs" 
                  v-model="add_on_1_premium"
                  placeholder="Enter Add On 1 Premium"
                  :value="formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 0">
                <label class="member-label">ADD ON 1 SUM ASSURED</label>
                <div>
                  <v-text-field
                  name="add_on_1_sum_assured"
                  ref="form_attrs" 
                  v-model="add_on_1_sum_assured"
                  placeholder="Enter Add On 1 Sum Assured"
                  :value="formAttr['value'] == 0 ? '0' : parseInt(formAttr['value'])"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 1">
                <label class="member-label">ADD ON 2 PREMIUM</label>
                <div>
                  <v-text-field
                  name="add_on_2_premium"
                  ref="form_attrs" 
                  v-model="add_on_2_premium"
                  placeholder="Enter Add On 2 Premium"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 1">
                <label class="member-label">ADD ON 2 SUM ASSURED</label>
                <div>
                  <v-text-field
                  name="add_on_2_sum_assured"
                  ref="form_attrs" 
                  v-model="add_on_2_sum_assured"
                  placeholder="Enter Add On 2 Sum Assured"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 2">
                <label class="member-label">ADD ON 3 PREMIUM</label>
                <div>
                  <v-text-field
                  name="add_on_3_premium"
                  ref="form_attrs" 
                  v-model="add_on_3_premium"
                  placeholder="Enter Add On 3 Premium"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="32" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 2">
                <label class="member-label">ADD ON 3 SUM ASSURED</label>
                <div>
                  <v-text-field
                  name="add_on_3_sum_assured"
                  ref="form_attrs" 
                  v-model="add_on_3_sum_assured"
                  placeholder="Enter Add On 3 Sum Assured"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 3">
                <label class="member-label">ADD ON 4 PREMIUM</label>
                <div>
                  <v-text-field
                  name="add_on_4_premium"
                  ref="form_attrs" 
                  v-model="add_on_4_premium"
                  placeholder="Enter Add On 4 Premium"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="42" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 3">
                <label class="member-label">ADD ON 4 SUM ASSURED</label>
                <div>
                  <v-text-field
                  name="add_on_4_sum_assured"
                  ref="form_attrs" 
                  v-model="add_on_4_sum_assured"
                  placeholder="Enter Add On 4 Sum Assured"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="12" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 4">
                <label class="member-label">ADD ON 5 PREMIUM</label>
                <div>
                  <v-text-field
                  name="add_on_5_premium"
                  ref="form_attrs" 
                  v-model="add_on_5_premium"
                  placeholder="Enter Add On 5 Premium"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col xs="52" md="6" class="member_relation_box col" 
              v-if="selectedAddOnPolicyName.length > 4">
                <label class="member-label">ADD ON 5 SUM ASSURED</label>
                <div>
                  <v-text-field
                  name="add_on_5_sum_assured"
                  ref="form_attrs" 
                  v-model="add_on_5_sum_assured"
                  placeholder="Enter Add On 5 Sum Assured"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
            <span
              v-bind:class="{'error-messagebox-login': isAddClassServerError}"
              id="server_side_error"
              >{{serverError}}</span
            >
            <v-row class="buttonbox">
              <v-btn class="blue-border-btn" @click="insuranceAccounts"> Cancel </v-btn>
              <v-btn
                class="blue-btn"
                @click="submit"
               
              >
                Save
              </v-btn>
            </v-row>
          </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios';
import Datepicker from 'vuejs-datepicker'
import { validationMixin } from 'vuelidate'
import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
import { Auth } from 'aws-amplify';
import JwtService from "../../.././common/jwt.service";
import { UPDATE_INSURANCE_FORM, EDIT_INSURANCE_FORM, GET_INSURANCE_FORM_DETAIL, GET_POLICY_NAME_DATA} from "../../../../store/actions.type";
import ApiService from "../../../../api/api.service";
import { isEmpty } from 'lodash';
export default{
    components: {
      Datepicker,
    },
    mixins: [validationMixin],
    validations: {
      
    },
    data: () => ({
      selectedPolicyName:[],
      valid: true,
      submitted: false,
      activePicker: null,
      menu: false,
      isFormValid:true,
      disabledDates: {
        from: new Date()
      },
      serverError:'',
      isAddClassServerError:false,
      formAttributes:'',
      formAttr:'',
      other_form_field:[],
      getLifeInsuranceCompany:[],
      additionalpolicy:[],
      policyName:[],
      familyMember:[],
      other_nominee:[],
      policy_type:'',
      curr_balance_date: '',
      account_type:'',
      bank_name:'',
      account_owne:'',
      addMoreField:[],
      nomineeMembers:[],
      form_id:'',
      account_owner:[],
      current_balance_value:'',
      maturity_balance_value:'',
      joint_account_owner:[],
      base_policy_premium:'',
      add_on_n_premium:[],
      total_premium:'',
      base_policy_sum_assured:'',
      add_on_n_sum_assured:[],
      policy_owner:[],
      insured_member:[],
      currentDate: new Date().setDate(new Date().getDate()),
      allow_nominee:1,
      addOnPolicyName:[],
      selectedAddOnPolicyName: [],
      selectedInsuredMember: [],
      disabledDatesforMaturity: {
        to: new Date()
      },
      addMoreFieldPolicy:[],
      add_on_1_premium:'',
      add_on_2_premium:'',
      add_on_3_premium:'',
      add_on_4_premium:'',
      add_on_5_premium:'',
      add_on_1_sum_assured:'',
      add_on_2_sum_assured:'',
      add_on_3_sum_assured:'',
      add_on_4_sum_assured:'',
      add_on_5_sum_assured:'',
    }), 
    created (){
      Fire.$on("loadData", () => {
        this.getEditFormDetail();
      });
    },
    mounted () {
      if(this.$store.getters.getUserDetails.user_name) this.getEditFormDetail();
    },
    watch: {
      formAttributes(newValue, oldValue) {
        newValue.forEach( (formAttr) => {
           if(formAttr.name == 'add_on_1_policy_name')
            { 
              var policyArr = [];
              this.selectedPolicyName.forEach((data)=>{
                if(formAttr.value.indexOf(data.id) !== -1)
                {
                  policyArr.push(data);
                }
              })
              this.selectedAddOnPolicyName = policyArr;
            }
            else if(formAttr.name == 'insurance_company')
            {
              this.insurance_company = parseInt(formAttr.value);
            }
            else if(formAttr.name == 'policy_type')
            {
              this.policy_type = formAttr.value;
            }
            else if(formAttr.name == 'policy_name')
            {
              this.policy_name1 = parseInt(formAttr.value);
            }
            else if(formAttr.name == 'add_on_1_premium'){
              this.add_on_1_premium = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_2_premium'){
              this.add_on_2_premium = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_3_premium'){
              this.add_on_3_premium = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_4_premium'){
              this.add_on_4_premium = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_5_premium'){
              this.add_on_5_premium = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_1_sum_assured'){
              this.add_on_1_sum_assured = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_2_sum_assured'){
              this.add_on_2_sum_assured = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_3_sum_assured'){
              this.add_on_3_sum_assured = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_4_sum_assured'){
              this.add_on_4_sum_assured = formAttr.value; 
            }
            else if(formAttr.name == 'add_on_5_sum_assured'){
              this.add_on_5_sum_assured = formAttr.value; 
            }
            else{
              
            }
        })
      }
    },
    methods: {
      changeTextFieldEvent(e) {
        this.isFormValid = this.$refs.form.validate()
      },
      validateUIN(event){
        this.isFormValid = this.$refs.form.validate()
        let actualstgLength = event.length
        if(actualstgLength >= 10){
          let uin_no =event;
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          ApiService.setHeader();
          ApiService.post('get-insurance-policy-name',{
            aws_cognito_id: cognito_idp,
            uin_number: uin_no,
          }).then( (response) => {
            if(response.data.data.insurance_company.length > 0){
              let insuranceId = response.data.data.insurance_company[0].id;
              let policyId = response.data.data.policy_name[0].id;
              let addonId = response.data.data.add_on_policy.length > 0 ? response.data.data.add_on_policy[0].id:0;
              this.getLifeInsuranceCompany.forEach(data =>{
                if(data.id == insuranceId)
                {
                  this.insurance_company = parseInt(data.id);
                  // this.insurance_company = {'id':data.id, 'name':data.name};
                  let company_id = data.id;
                  this.$store.dispatch(GET_POLICY_NAME_DATA, {
                    data: {
                      insurance_company_id:company_id,
                      aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
                    },
                    api: 'get-insurance-policy-name',
                  }).then(() => {
                  this.policyName = [];
                  this.addOnPolicyName = [];
                  this.$store.getters.getPolicyNameData.data.policy_name.forEach(policy => {
                    this.policyName.push({'id':policy.id, 'name':policy.policy_name,'policy_type':policy.policy_type});
                  })
                  this.policyName.forEach(policy => {
                    if(policy.id == policyId)
                    {
                      this.policy_name1 = parseInt(policy.id);
                      // this.policy_name1 = {'id':policy.id, 'name':policy.policy_name};
                      this.policy_type = policy.policy_type;
                    }
                  })
                  this.$store.getters.getPolicyNameData.data.add_on_policy.forEach(add_on_policy => {
                    this.addOnPolicyName.push({'id':add_on_policy.id, 'name':add_on_policy.policy_name});
                  })
                  this.addOnPolicyName.forEach(add_on_policy => {
                    if(add_on_policy.id == addonId)
                    {
                      this.selectedAddOnPolicyName = [{'id':add_on_policy.id, 'name':add_on_policy.name}];
                    }
                  })
                 }).catch(() => {

                 })
                }
              })
            }
            else{
              this.insurance_company = [];
              this.policy_name1 = [];
              this.policy_type = '';
              this.policyName = [];
              this.addOnPolicyName = [];
              this.selectedAddOnPolicyName = [];
            }
          })
        }
      },
      limiter(e) {
      if((e.length + this.other_form_field.length) > 3) {
        swal.fire({
              title: 'Nominee',
              text: "You can add maximum 3 nominees.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
                
              }
            })
      }
    },
      validate () {
        this.$refs.form.validate()
      },
      backButton(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: 'Investment'}).catch(()=>{})
          }
        }) : this.$router.push({ name: 'Investment'}).catch(()=>{});
      },
      insuranceAccounts(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          if (result.isConfirmed) {
            this.$router.push({ name: 'SubCategory'}).catch(()=>{})
          }
        }) : this.$router.push({ name: 'SubCategory'}).catch(()=>{});
      },
       
      submit(e) {
        this.checkFormData = [];
        this.isFormValid = this.$refs.form.validate()
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        if (this.checkFormData.length > 0) {
            this.submitted = true;
            this.$loading(true)
            var vm = this
            let jsonObject = []
            let addOnPolicyName = []
            let insuredMember = []
            let i=0;
            
            for (const [key, value] of formData.entries()) {
              if(key == 'insured_member_1' && value !=''){
                value.split(",").forEach(data => {
                  insuredMember.push(data)
                });
              }
              else if(Number.isInteger(parseInt(key)) == true){
                insuredMember.push(value)
              }
              else if(key == 'add_on_1_policy_name' && value !=''){
                this.selectedAddOnPolicyName.forEach(data => {
                  addOnPolicyName.push(data.id)
                });
              }
              else if(key == 'insurance_company' || key == 'policy_name' || key == 'policy_owner'){
                jsonObject.push({"key":key, "values":parseInt(value)})
              }
              else{
                if(key != 'add_on_1_policy_name' && key != 'insured_member_1' && key != 'add_on_1_premium' && key != 'add_on_2_premium' && key != 'add_on_3_premium' && key != 'add_on_4_premium' && key != 'add_on_5_premium' && key != 'add_on_1_sum_assured' && key != 'add_on_2_sum_assured' && key != 'add_on_3_sum_assured' && key != 'add_on_4_sum_assured' && key != 'add_on_5_sum_assured'){
                  jsonObject.push({"key":key, "values":value})
                  i++;
                }
              }
            }
            let insuredMemberArr = {"key":"insured_member_1", "values":insuredMember}
            let dataArr = {"key":"add_on_1_policy_name", "values":addOnPolicyName}
            let dynamicFields = [
              { "key" : "add_on_1_premium", 'values': this.add_on_1_premium},
              { "key" : "add_on_2_premium", 'values': this.add_on_2_premium},
              { "key" : "add_on_3_premium", 'values': this.add_on_3_premium},
              { "key" : "add_on_4_premium", 'values': this.add_on_4_premium},
              { "key" : "add_on_5_premium", 'values': this.add_on_5_premium},
              { "key" : "add_on_1_sum_assured", 'values': this.add_on_1_sum_assured},
              { "key" : "add_on_2_sum_assured", 'values': this.add_on_2_sum_assured},
              { "key" : "add_on_3_sum_assured", 'values': this.add_on_3_sum_assured},
              { "key" : "add_on_4_sum_assured", 'values': this.add_on_4_sum_assured},
              { "key" : "add_on_5_sum_assured", 'values': this.add_on_5_sum_assured},
            ];
            jsonObject.push(dataArr)
            jsonObject.push(insuredMemberArr)
            dynamicFields.map(element => {
              jsonObject.push(element)
            });
            let collected_data = {"collected_data":jsonObject};
            this.$loading(false)
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            this.$store.dispatch(UPDATE_INSURANCE_FORM, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:atob(this.$route.params.id),
                account_owner:getFormData.policy_owner.value,
                form_detail:JSON.stringify(collected_data),
              },
              api: 'update-insurance-form-details',
            }).then(() => {
                this.savingAccountList();
                this.$loading(false)
                Toast.fire({
                    icon: 'success',
                    title: "Data added successfully"
                  })
              this.$router.push({ name: "insurance-dashboard", params: { tab: 'tab-3' }}).catch(()=>{});
            }).catch(() => {
                this.$loading(false)
            })

        }else{
          return;
        }
      },
      setMasterData:function(attr_type, val){

        if (attr_type == 'insurance_company') {
          let company_id = val;
          this.$store.dispatch(GET_POLICY_NAME_DATA, {
            data: {
              insurance_company_id:company_id,
              aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
            },
            api: 'get-insurance-policy-name',
          }).then(() => {
          this.policyName = [];
          this.addOnPolicyName = [];
          this.$store.getters.getPolicyNameData.data.policy_name.forEach(policy => {
            this.policyName.push({'id':policy.id, 'name':policy.policy_name});
          })
          this.$store.getters.getPolicyNameData.data.add_on_policy.forEach(add_on_policy => {
            this.addOnPolicyName.push({'id':add_on_policy.id, 'name':add_on_policy.policy_name});
          })
         }).catch(() => {

         })
       }
       else if(attr_type == 'policy_name')
       {
        this.$store.getters.getPolicyNameData.data.policy_name.forEach(policy => {
          if(policy.id == val)
          {
            this.policy_type = policy.policy_name;
          } 
        })
       }
        else if(attr_type == 'add_on_1_policy_name')
        {
          if(!(this.selectedAddOnPolicyName.length < 6)){
            this.selectedAddOnPolicyName.splice(5, 1);
            swal.fire({
              title: '',
              text: "You can add maximum 5 policies.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                return;
              }
            })
          }
        }
        else if (attr_type == 'account_owner') {
          let masterDataArr = this.$store.getters.getEditInsuranceForm.data.master_data;
          let i = 0;
          this.nominee = [];
          this.policy_owner = [];
          this.joint_account_owner = [];
          masterDataArr['0']['FamilyMember'].forEach(
            familyMember => {
              if (parseInt(val) != parseInt(familyMember['id'])) {
                  this.nominee.push(familyMember.name);
                 if(familyMember.id == 0){
                this.policy_owner.push({'id':'0', 'name':familyMember.name});
              }
              else{
                this.policy_owner.push({'id':familyMember.id, 'name':familyMember.name});
              }
              this.insured_member.push({'id':familyMember.id, 'name':familyMember.name});
              }
              i++;
          });
        }
      },
      appendFieldOnNominee(attr_type, val){
        this.nominee.push(val);
        this.addMoreField.push(val);
        this.other_form_field.splice(attr_type, 1);
      },
      insuranceDashbord(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: "insurance-dashboard"}).catch(()=>{})
          }
        }) : this.$router.push({ name: "insurance-dashboard"}).catch(()=>{});
      },

      savingAccountList(){
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$store.dispatch(GET_INSURANCE_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-insurance-form-details",
        })
        .then(() => {
            Fire.$emit('insuranceGraphData');
             this.$loading(false);

        }).catch(() => {
           this.$loading(false);
        });
      },
     

      getEditFormDetail (){
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name = this.$store.getters.getUserDetails.user_name;
          let selected_value = this.$store.getters.getUserDetails.selected_value;
          this.$store.dispatch(EDIT_INSURANCE_FORM, {
            data: {
              aws_cognito_id: cognito_idp,
              user_name: user_name,
              form_type: 7,
              form_id: parseInt(atob(this.$route.params.id)),
            },
            api: "get-insurance-edit-form-details",
          })
          .then(() => {
          this.allow_nominee = this.$store.getters.getEditInsuranceForm.allow_nominee;
          this.form_id = this.$store.getters.getEditInsuranceForm.data.form_id;
          this.formAttributes = this.$store.getters.getEditInsuranceForm.data.form_attributes.fields;
          this.formAttributes.forEach(element=>{
            if (element.name=='add_on_1_premium' || element.name=='add_on_2_premium' || element.name=='add_on_3_premium' || element.name=='add_on_4_premium' || element.name=='add_on_5_premium') {
              this.add_on_n_premium.push(element);
            }
            if (element.name=='add_on_1_sum_assured' || element.name=='add_on_2_sum_assured' || element.name=='add_on_3_sum_assured' || element.name=='add_on_4_sum_assured' || element.name=='add_on_5_sum_assured') {
              this.add_on_n_sum_assured.push(element);
            }
          });
          this.$store.getters.getEditInsuranceForm.data.nominee_options.forEach(nomineeOptions => {
            this.addMoreField.push(nomineeOptions)
          });

          let masterDataArr = this.$store.getters.getEditInsuranceForm.data.master_data;
          masterDataArr.forEach(element => {
            if (element.getLifeInsuranceCompany) {
              element.getLifeInsuranceCompany.forEach(dataLifeInsuranceCompany => {
                this.getLifeInsuranceCompany.push({'id':dataLifeInsuranceCompany.id, 'name':dataLifeInsuranceCompany.name});
              });
            }
            if (element.policyName) {
              element.policyName.forEach(dataPolicyName => {
                this.policyName.push({'id':dataPolicyName.id, 'name':dataPolicyName.policy_name});
              });
            }
            if (element.additionalpolicy) {
              element.additionalpolicy.forEach(add_on_policy => {
                this.selectedPolicyName.push({'id':add_on_policy.id, 'name':add_on_policy.policy_name});
                this.addOnPolicyName.push({'id':add_on_policy.id, 'name':add_on_policy.policy_name});
              });
            }
            if (element.FamilyMember) {
              element.FamilyMember.forEach(dataFamily => {
               if(dataFamily.id == 0){
                this.policy_owner.push({'id':'0', 'name':dataFamily.name});
              }
              else{
                this.policy_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
              }
              this.insured_member.push({'id':dataFamily.id, 'name':dataFamily.name});
              });
            }
          });

          this.$loading(false)
        })
        .catch(function (error) {
          console.log(error)
           this.$loading(false)
        }); 
      },
  }
};
</script>